<template>
	<v-card color="rgba(41, 41, 47, 0.8)">
		<v-card-title> {{ $t("EXPORT_AS") }} </v-card-title>
		<v-card-text>
			<v-card-title class="justify-center text-center" style="word-break:break-word;white-space: break-spaces;">
				{{ $t('ExportRoad', { name: lineName }) }}<br />
				{{ $t('SelectOutputFormat') }}
			</v-card-title>
			<v-radio-group v-model="selectedExportFormat">
				<v-radio name="format" label="DXF" value="dxf"></v-radio>
				<v-radio name="format" label="SIMA" value="sima"></v-radio>
			</v-radio-group>
			<v-row class="ma-0">
				<v-col>
					<v-card-actions class="justify-end">
						<v-btn variant="flat" @click="closeDialog" color="red">
							{{ $t("CANCEL") }}
						</v-btn>
						<v-btn variant="flat" @click="exportLineworks()" color="primary" :disabled="!selectedExportFormat">
							{{ $t("EXPORT_AS") }}
						</v-btn>
					</v-card-actions>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import { notifyError } from "@/utils/notificationUtils";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import {
	GoogleAnalyticsClickTypes,
	addClickTypeLog,
} from "../../../utils/googleAnalytics.js";

export default {
	name: "ExportLineworksFormatDialog",
	props: {
		entity: {
			type: Object,
			required: true,
		},
	},
	emits: ["close"],
	setup(_props, { emit }) {
		const store = useStore();
		const { t } = useI18n();

		return {
			store,
			t,
		};
	},
	data() {
		return {
			selectedExportFormat: "dxf",
		};
	},
	computed: {
		lineName() {
			return this.entity?.lineName || "";
		},
	},
	methods: {
		closeDialog() {
			this.$emit("close");
		},

		async exportLineworks() {
			if (this.selectedExportFormat === "sima") {
				await this.exportSima();
			} else if (this.selectedExportFormat === "dxf") {
				await this.exportDxf();
			}
			this.closeDialog();
		},

		async exportSima() {
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_LINE_EXPORT);
			await this.store.dispatch("executeWithSpinner", async () => {
				try {
					const lineType = this.entity?.lineType;
					const payload = {
						viewerLineId: this.entity?.viewerLineId,
						lineName: this.entity?.lineName,
						siteName: this.store.state.site.site_name,
					};

					if (lineType === "arbitrary") {
						await this.store.dispatch(
							"lineWorksCenterline/exportArbitraryLineToSIMA",
							payload,
						);
					} else if (lineType === "sima") {
						await this.store.dispatch(
							"lineWorksCenterline/exportSIMAToSIMA",
							payload,
						);
					} else if (lineType === "dxf") {
						await this.store.dispatch(
							"lineWorksCenterline/exportDXFToSIMA",
							payload,
						);
					} else if (lineType === "alignment" || this.entity?.type) {
						await this.store.dispatch(
							"lineWorksCenterline/exportAlignmentToSIMA",
							payload,
						);
					} else if (lineType) {
						await this.store.dispatch(
							"lineWorksCenterline/exportLineWorksSima",
							payload,
						);
					}
				} catch (e) {
					console.error(e);
					notifyError(
						this,
						this.t("LINEWORKS_EXPORT_FAILED", {
							name: this.entity.lineName,
						}),
					);
				}
			});
		},

		async exportDxf() {
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_LINE_EXPORT);

			await this.store.dispatch("executeWithSpinner", async () => {
				try {
					const lineType = this.entity?.lineType;
					const payload = {
						viewerLineId: this.entity?.viewerLineId,
						lineName: this.entity?.lineName,
					};

					if (lineType === "arbitrary") {
						await this.store.dispatch(
							"lineWorksCenterline/exportArbitraryLineToDXF",
							payload,
						);
					} else if (lineType === "sima") {
						await this.store.dispatch(
							"lineWorksCenterline/exportSIMAToDXF",
							payload,
						);
					} else if (lineType === "dxf") {
						await this.store.dispatch(
							"lineWorksCenterline/exportDXFToDXF",
							payload,
						);
					} else if (lineType === "alignment" || this.entity?.type) {
						await this.store.dispatch(
							"lineWorksCenterline/exportAlignmentToDXF",
							payload,
						);
					} else if (lineType) {
						await this.store.dispatch(
							"lineWorksCenterline/exportLineWorksDXF",
							payload,
						);
					}
				} catch (error) {
					console.error(error);
					notifyError(
						this,
						this.t("LINEWORKS_EXPORT_FAILED", {
							name: this.entity?.lineName,
						}),
					);
				}
			});
		},
	},
};
</script>

<style scoped>
.v-card-title {
	font-size: 16px;
	font-weight: bold;
}
</style>
